<template>
  <div class="container">
    <h4 class="my-3">Edição de Perfis de Acesso
      <b-button v-b-modal="'create-profile-modal'" variant="success">Criar Novo Perfil de Acesso</b-button>
      <b-modal id="create-profile-modal"
        @ok="handleOk"
        @show="resetModal"
        @hidden="resetModal"
        ok-variant="success"
        ok-title="Criar"
        title="Novo Perfil de Acesso">
        <b-form ref="formCreateProfile" @submit.stop.prevent="handleSubmit">
          <b-form-group id="input-group-profile" :state="nameState" label="Nome do Perfil de Acesso:" label-for="input-profile"
            invalid-feedback="Nome do Perfil é necessário">
            <b-form-input id="input-profile" :state="nameState" v-model="profileName" required placeholder="Digite um Nome para o Perfil de Acesso"></b-form-input>
          </b-form-group>
        </b-form>
        <div v-if="modalLoading" class="text-center">
            <b-spinner label="Busy" class="m-1"></b-spinner>
        </div>
      </b-modal>
    </h4>

    <b-card no-body class="mb-3">
      <b-tabs v-model="selectedProfile" pills card vertical>
        <div v-if="getProfiles.length == 0" class="text-center">
          <b-spinner label="Busy" class="mt-5"></b-spinner>
        </div>
        <div v-else>
          <b-tab
            v-for="profile in getProfiles"
            :key="profile.id"
            v-bind:title="profile.name"
            lazy
          >
          <Profile :profileId="profile.id"></Profile>
          </b-tab>
        </div>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Profile from "./Profile.vue";
export default {
  name: "EditProfile",
  components: {
    Profile
  },
  data(){
    return {
      profileName: "",
      nameState: null,
      selectedProfile: 0,
      modalLoading: false
    };
  },
  computed: {
    getProfiles() {
      return this.$store.getters.getProfiles;
    }
  },
  created() {
    this.$store.dispatch("retrieveProfiles");
  },
  methods: {
    createProfile(callback){
      this.modalLoading = true;
      // Create the new Profile
      this.$store.dispatch("createProfile", this.profileName)
      .then(profileResponse => {
        // Update profiles
        this.$store.dispatch("retrieveProfiles")
          .then(() => {
            callback();
            // This horrible thing was done to try to select the new profile in the list after DOM reload
            // this.$nexttick was not enough
            setTimeout(() =>{
              this.selectedProfile = this.getProfiles.findIndex(element => {
                return element.id === profileResponse.data.id;
              }, 900);
            });
          });
      })
      .catch(error => {
          console.error(error);
          this.$store.dispatch("destroyToken");
          this.$router.push({ name: "login" });
      });
    },
    checkFormValidity() {
      const valid = this.$refs.formCreateProfile.checkValidity()
      this.nameState = valid;
      return valid
    },
    resetModal() {
      this.profileName = '';
      this.nameState = null;
      this.modalLoading = false;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Hide the modal manually
      var hideModal = () => {
        this.$nextTick(() => {
          this.$bvModal.hide('create-profile-modal')
        });
      }
      // Create the new Profile
      this.createProfile(hideModal);
      
    },
    makeToast(variant = null, content) {
      this.$bvToast.toast(content, {
        title: 'Aviso',
        variant: variant,
        solid: true
      })
    },
  }
};
</script>

<style>
</style>